export const SHOW_MESSAGE = 'SHOW_MESSAGE';

export default {
    namespaced: true,
    state: {
        content: "",
        color: "",
    },
    mutations: {
        [SHOW_MESSAGE](state, payload) {
          state.content = payload.content
          state.color = payload.color
        },
      }
}
